import { connect } from 'react-redux';
import FindWorks from './find_works';
import {
  loadNextPage, loadArtFilters, addFilter, removeFilter
} from '../../actions/works';
import { closePanel } from '../../actions/panel';
import { addToCanvas } from '../../actions/canvas';
import { showMoreLikeThis } from '../../actions/more_like_this';

const mapStateToProps = ({ works, pin }) => ({ ...works, ...pin });

export default connect(mapStateToProps, {
  loadNextPage,
  addToCanvas,
  closePanel,
  loadArtFilters,
  addFilter,
  removeFilter,
  showMoreLikeThis
})(FindWorks);
